'use client'

import React from 'react'
import Link from 'next/link'
import { useIsMobile } from '@/lib/mobileDetector'
import { useBreakpoint } from '@/hooks/useBreakpoints'
import { isAnySignupPath, storeHomePath } from '@/lib/namedRoutes'
import { StoreAnalytics, trackStoreEvent } from '@nile/mantine-theme/analytics'
import { appPath } from '@/lib/getPublicAppUrl'

interface LogoProps {
    pathname: string
    isFromGenAi: boolean
}

export function Logo({ pathname, isFromGenAi }: LogoProps) {
    const { isSm } = useBreakpoint()
    const isMobile = useIsMobile()
    const isSignupPath = isAnySignupPath(pathname)
    const { src, size } = resolveLogo({ isSignupPath, isFromGenAi, isMobile, isSm })

    return (
        <Link
            href={storeHomePath}
            onClick={() => trackStoreEvent(StoreAnalytics.NAV_HEADER_CLICKED, { name: 'logo' })}
            data-dd-privacy="allow"
            data-testid="site-logo"
            style={{ textDecoration: 'none', cursor: 'pointer' }}
        >
            <img data-dd-privacy="allow" src={src} alt="General" height={size} />
        </Link>
    )
}

// Per-page logo overrides: GenAi flows use the inverse / white lockup,
// the mobile signup flow shows the cross-only mark, and everything else gets
// the default storefront lockup.
function resolveLogo({
    isSignupPath,
    isFromGenAi,
    isMobile,
    isSm,
}: {
    isSignupPath: boolean
    isFromGenAi: boolean
    isMobile: boolean
    isSm: boolean
}) {
    if (isFromGenAi && !isSignupPath) {
        return {
            src: isMobile ? appPath('/logo-intermediary.svg') : appPath('/logo-gm-white.svg'),
            size: isSm || isMobile ? 32 : 35,
        }
    }
    if (isSignupPath && isSm) {
        return { src: appPath('/logo.svg'), size: 56 }
    }
    return { src: appPath('/logo-gm.svg'), size: isSm || isMobile ? 32 : 35 }
}
